<app-form-page>
  @if (isLoadingInitialData) {
    <div class="form-skeleton" aria-busy="true">
      <div class="form-skeleton__header">
        <div class="form-skeleton__line"></div>
        <div class="form-skeleton__line"></div>
      </div>
      <div class="form-skeleton__line form-skeleton__line--short"></div>
      <div class="form-skeleton__field"></div>
      <div class="form-skeleton__field"></div>
      <div class="form-skeleton__row">
        <div class="form-skeleton__field"></div>
        <div class="form-skeleton__field"></div>
      </div>
      <div class="form-skeleton__field"></div>
      <div class="form-skeleton__actions">
        <div class="form-skeleton__button"></div>
      </div>
    </div>
  } @else {
  <form [formGroup]="form" class="banking-form">
    <mat-stepper [linear]="true" orientation="horizontal">
      <mat-step [stepControl]="contractPartnerGroup">
        <ng-template matStepLabel>Vertragspartner</ng-template>

        <ng-template matStepContent>
          <h2>Vertragspartner</h2>

          <div formGroupName="contractPartner" class="partner-grid">
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
              <mat-label>Firmenname</mat-label>
              <input matInput formControlName="companyName" autocomplete="organization" required>
              <mat-error>Firmenname ist erforderlich.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
              <mat-label>Strasse / Nr.</mat-label>
              <input matInput formControlName="streetAndNumber" autocomplete="street-address" required>
              <mat-error>Strasse / Nr. ist erforderlich.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="postal-code">
              <mat-label>PLZ</mat-label>
              <input matInput formControlName="postalCode" autocomplete="postal-code" required>
              <mat-error>PLZ ist erforderlich.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="city">
              <mat-label>Ort</mat-label>
              <input matInput formControlName="city" autocomplete="address-level2" required>
              <mat-error>Ort ist erforderlich.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
              <mat-label>Land</mat-label>
              <input matInput formControlName="country" autocomplete="country-name" required>
              <mat-error>Land ist erforderlich.</mat-error>
            </mat-form-field>
          </div>

          <div class="step-actions step-actions--end">
            <button mat-flat-button type="button" matStepperNext>
              Weiter
            </button>
          </div>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="persons">
        <ng-template matStepLabel>Person(en)</ng-template>

        <ng-template matStepContent>
          <h2>Person(en)</h2>
          <p class="form-copy">
            Der Vertragspartner erklärt hiermit, dass die nachfolgend aufgeführte(n) Person(en) an den in die
            Geschäftsbeziehung eingebrachten Vermögenswerten wirtschaftlich berechtigt ist/sind. Ist der
            Vertragspartner selber alleine an diesen Vermögenswerten wirtschaftlich berechtigt, so sind nachstehend
            seine Personalien festzuhalten.
          </p>

          <div formArrayName="persons">
            <div class="persons-list">
              <section *ngFor="let person of persons.controls; let personIndex = index" [formGroupName]="personIndex" class="person">
                <div class="person-header">
                  <h3>Person {{ personIndex + 1 }}</h3>
                  <button mat-stroked-button type="button" (click)="removePerson(personIndex)" [disabled]="persons.length === 1">
                    Entfernen
                  </button>
                </div>

                <div class="person-grid">
                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Vorname</mat-label>
                    <input matInput formControlName="firstName" autocomplete="given-name" required>
                    <mat-error>Vorname ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Nachname</mat-label>
                    <input matInput formControlName="lastName" autocomplete="family-name" required>
                    <mat-error>Nachname ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Geburtsdatum</mat-label>
                    <input matInput formControlName="birthDate" autocomplete="bday">
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Strasse / Nr.</mat-label>
                    <input matInput formControlName="streetAndNumber" autocomplete="street-address" required>
                    <mat-error>Strasse / Nr. ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="postal-code">
                    <mat-label>PLZ</mat-label>
                    <input matInput formControlName="postalCode" autocomplete="postal-code" required>
                    <mat-error>PLZ ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="city">
                    <mat-label>Ort</mat-label>
                    <input matInput formControlName="city" autocomplete="address-level2" required>
                    <mat-error>Ort ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Land</mat-label>
                    <input matInput formControlName="country" autocomplete="country-name" required>
                    <mat-error>Land ist erforderlich.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="full-width">
                    <mat-label>Nationalität</mat-label>
                    <input matInput formControlName="nationality" autocomplete="country-name">
                  </mat-form-field>
                </div>
              </section>
            </div>
          </div>

          <div class="repeatable-actions">
            <button mat-stroked-button type="button" (click)="addPerson()">
              Weitere Person hinzufügen
            </button>
          </div>

          <div class="form-copy form-copy--legal">
            <p>Der Vertragspartner verpflichtet sich, Änderungen jeweils unaufgefordert mitzuteilen.</p>
            <p>
              Die vorsätzliche Angabe falscher Informationen in diesem Formular ist eine strafbare Handlung
              (Urkundenfälschung gemäss Artikel 251 des Schweizerischen Strafgesetzbuchs)
            </p>
          </div>

          <div class="step-actions">
            <button mat-stroked-button type="button" matStepperPrevious>
              Zurück
            </button>
          </div>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </form>
  }
</app-form-page>
